// modules
import {
  CloseIcon,
  DropDown,
  DropdownButton,
  Radio,
  Text,
  View,
} from '@upstox/upstox-ui';
import React, { FC, useCallback, useState } from 'react';
import { observer } from 'mobx-react';
import LocaleService from 'modules/Localization';
import { useStore } from 'modules/Stores';
// components
import PriceAlertsLoadingHeader from 'modules/PriceAlerts/components/PriceAlertsLoadingState/PriceAlertsLoadingHeader';
// typings
import { PriceAlertsListProps } from './typings';
// constants
import { DropDownValues } from './constants';
// styles
import * as css from './styles';

const PriceAlertsListHeader: FC<PriceAlertsListProps> = ({ closeModal }) => {
  const { selectedStatus, setSelectedStatus } = useStore('PriceAlertsStore');
  const [isOpen, setIsOpen] = useState(false);
  const { getLoading } = useStore('LoadingStore');
  const { getError } = useStore('ErrorStore');
  const isLoading = getLoading('PRICE_ALERT');
  const isError = getError('PRICE_ALERT');

  const handleOpenDropdown = useCallback(() => {
    setIsOpen(true);
  }, [setIsOpen]);

  const handleCloseDropdown = useCallback(() => {
    setIsOpen(false);
  }, [setIsOpen]);

  if (isLoading) {
    return <PriceAlertsLoadingHeader closeModal={closeModal} />;
  }

  return (
    <View css={css.header}>
      <Text css={css.title}>{LocaleService.translate('PRICE_ALERTS')}</Text>
      <View alignItems="center" gap={12}>
        {!isError && (
          <React.Fragment>
            <Text variant="meta" family="tvFont">
              {LocaleService.translate('STATUS')}:
            </Text>
            <DropDown
              initialOpen={false}
              onClose={handleCloseDropdown}
              onOpen={handleOpenDropdown}
              isOpen={isOpen}
              minWidth={160}
              renderTrigger={({ onOpen, onClose, open, ...otherProps }) => (
                <DropdownButton
                  text={selectedStatus}
                  isOpen={false}
                  onClick={open ? onClose : onOpen}
                  textFont="tvFont"
                  css={css.dropdownButton}
                  {...otherProps}
                />
              )}
            >
              <View flexDirection="column">
                {DropDownValues.map(item => (
                  <View
                    key={item.value}
                    alignItems="center"
                    css={css.dropdownOption}
                    onClick={() => {
                      setSelectedStatus(item.value);
                      setIsOpen(false);
                    }}
                    gap="xsmall"
                  >
                    <Radio readOnly checked={item.value === selectedStatus} />
                    <Text variant="body" size="s" weight="normal" family="tvFont">
                      {item.title}
                    </Text>
                  </View>
                ))}
              </View>
            </DropDown>
          </React.Fragment>
        )}

        <CloseIcon css={css.closeIcon} onClick={closeModal} />
      </View>
    </View>
  );
};

export default observer(PriceAlertsListHeader);
